// extracted by css-extract-rspack-plugin
export default {"filters":"_9fd9be0a","title":"_c094de79"};